import core from './scripts/paywall/core/core';
import configCommon from './scripts/common/config';
import frameEvent from './scripts/common/frame-event';
import config from './scripts/paywall/core/config';
import smartlock from './scripts/common/smartlock';
import _ls from './scripts/common/localstorage';
import customDimension from './scripts/common/customDimension';
import analytics from './scripts/paywall/core/analytics';
import message from './scripts/paywall/core/message';
import router from './scripts/paywall/core/router';
import helper from './scripts/paywall/core/helper';
import service from './scripts/paywall/core/service';
import iframe from './scripts/paywall/core/iframe';

import model from './scripts/paywall/core/model';
import appevents from './scripts/paywall/core/appEvent';
import hotjar from './scripts/paywall/core/hotjar';
import wcentrix from './scripts/common/wcentrix';
import logger from './scripts/paywall/core/logger';   
import validation from './scripts/paywall/core/validation';

import credencialHandler from './scripts/paywall/handlers/credencialHandler';
import flowHandler from './scripts/paywall/handlers/flowHandler';
import paywallHandler from './scripts/paywall/handlers/paywallHandler';
import stepHandler from './scripts/paywall/handlers/stepHandler';

import credencialController from './scripts/paywall/controllers/credencialController';
import flowController from './scripts/paywall/controllers/flowController';
import paywallController from './scripts/paywall/controllers/paywallController';
import fbIA from "./scripts/paywall/controllers/fbInstantArticlesController";

import swgController from './scripts/paywall/controllers/swgController';

import views from './scripts/paywall/views/paywallView';
import partials from './scripts/paywall/views/partials';

import app from "./scripts/paywall/app";



// EXT
import jquerynicSelect from './scripts/ext/jquery.nice-select';
import jqueryautoTab from './scripts/ext/jquery.autotab';


// Styles
import './styles/formularios.css';
import './styles/reset.css';
import './styles/login.css';
import './styles/paywall2.css';
import './styles/pin.css';
import './styles/carrito.css';
import './styles/images.css';

//const Initialize = () => {
    
//}

//app.on(Events.APP_START, Initialize);
//app.start();






// WEBPACK FOOTER //
// ./Statics/paywall.js